// Shop-owner tow requests: one request can need several drivers, each accepted offer is its own trip.
export const isShopRequest = (doc) => doc?.requesterType === 'shopOwner';

export const TRIP_STATE_LABELS = {
    pending: 'بانتظار البدء',
    driver_on_the_way: 'السائق في الطريق',
    trip_started: 'جارية',
    completed: 'مكتملة',
    cancelled: 'ملغاة',
    faild: 'فشلت',
};

export const REQUESTER_FILTERS = [
    { value: '', label: 'الكل' },
    { value: 'user', label: 'المستخدمين' },
    { value: 'shopOwner', label: 'الورش' },
];

// Live trips of a multi-driver request (cancelled ones free their slot).
export const liveTripsCount = (trips = []) => trips.filter((t) => !['cancelled', 'faild'].includes(t.state)).length;
